<template>
  <div>
    <v-tabs v-model="tab" background-color="transparent" grow>
			<v-tab				
				href="#tab-1" 
				
			>
				CARGAR HISTORIAL DE AVANCES
			</v-tab>
			<v-tab
				href="#tab-2" 
			>
				CARGAR HISTORIAL PAROS
			</v-tab>
			

			<v-tabs-items v-model="tab" touchless>
				<v-tab-item
					:key="1" :value="'tab-1'"  eager
				>
					<v-col cols="12">  
            <v-row>
              <v-col cols="4">
                <v-autocomplete v-model="data.idOrdenTrabajo" label="Orden de trabajo" :items="Tbtdboper"
                  item-value="idTrabajoOrden" item-text="clave" :loading="loadingTbtdboper" clearable />
              </v-col>
            
              <v-col cols="4">
                <v-autocomplete v-model="data.idDetalleOrdenTrabajo" label="Artículo" :items="trabajoOrdenesDetalles"
                  item-value="idTrabajoOrdenDetalle" item-text="clave" clearable />
              </v-col>
            
              <v-col cols="4">
                <v-autocomplete v-model="data.idOperacion" label="Operación" :items="operaciones" item-value="idOperacion"
                  item-text="articulo" clearable />
              </v-col>
            
              <v-col cols="4">
                <v-autocomplete v-model="data.idMaquinaInstancia" label="Máquina" :items="instancias" item-value="idMaquinaIns"
                  item-text="nombre" clearable />
              </v-col>
            
              <v-col cols="4">
                <v-autocomplete v-model="data.idToken" label="Token" :items="tokensExtrasMaquina" item-value="idTokenExtra"
                  :item-text="nombreToken" clearable />
              </v-col>
                        
              <v-col cols="12">
                <div class="d-flex">
                  <!-- <a :href="'/api/Reportes/PlantillaCargaMasivaAvancesProduccion?access_token=' + token" target="_blank"
                    class="caption">
                    <v-icon color="blue">mdi-download</v-icon>Descargar Plantilla de
                    Carga Masiva Para Avances de Producción
                  </a> -->
                  <v-btn color="primary" text class="ml-auto" :loading="loadingCargaDescarga"
                    @click="descargarPlantilla()">Descargar Plantilla</v-btn>
                  <v-btn color="primary" text :loading="loadingCargaDescarga" :disabled="!comprobacionFormulario"
                    @click="abrirDialog()">
                    Subir Archivo
                  </v-btn>
                
                </div>
              </v-col>
            </v-row>                  
            <v-dialog v-model="dialog" width="500">
              <v-card>
                <v-col cols="12">
                  <v-card-text v-if="errorCargaMasiva" class="text-center">
                    <h3>Se ha producido un Error. Intente una vez más.</h3>
                    <v-btn depressed color="red" text @click="resetCargaMasiva">Aceptar</v-btn>
                  </v-card-text>
                
                  <v-card-text v-else-if="cargaCargaCompleta" class="text-center">
                    <h3 v-if="cargaLink === ''">Carga Realizada Satisfactoriamente</h3>
                    <div v-else>
                      <h3>Carga Realizada Parcialmente</h3>
                      <a :href="`/api/Articulos/ReporteCargaMasiva/${cargaLink}?access_token=${token}`" target="_blank">Archivo
                        de
                        Reporte</a>
                    </div>
                    <v-btn depressed color="green" text @click="resetCargaMasiva">Aceptar</v-btn>
                  </v-card-text>
                
                  <v-card-text v-else-if="loadingCargaMasiva" class="text-center">
                    <h3>Cargando</h3>
                    <v-progress-circular :size="75" color="green" indeterminate />
                  </v-card-text>
                
                  <v-card-text v-else class="text-center">
                    <v-file-input v-model="selectedUpdateFile" accept=".csv, .xls, .xlsx" @change="cambioficheroCarga" counter
                      show-size clearable label="Formato xlsx en formato general (Sin formato especifico)" />
                  
                    <v-row class="mt-4">
                      <v-col cols="12" class="py-0">
                        <v-btn block color="blue" outlined class="my-2" @click="cargaProduccionMasiva()">
                          Cargar Producción
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-col>
              </v-card>
            </v-dialog>
          
          </v-col>
				</v-tab-item>
				<v-tab-item
					:key="2" :value="'tab-2'"  eager
				>
          <v-card-text
		      	
		      >
		      	<!-- <p class="mb-0 text-h6 text--secondary text-left">
		      		Carga Masiva de Artículos
		      	</p> -->
		      	<v-row>
              <v-col cols="4">
                <v-autocomplete v-model="data.idOrdenTrabajo" label="Orden de trabajo" :items="Tbtdboper"
                  item-value="idTrabajoOrden" item-text="clave" :loading="loadingTbtdboper" clearable />
              </v-col>
            
              <v-col cols="4">
                <v-autocomplete v-model="data.idDetalleOrdenTrabajo" label="Artículo" :items="trabajoOrdenesDetalles"
                  item-value="idTrabajoOrdenDetalle" item-text="clave" clearable />
              </v-col>
            
              <v-col cols="4">
                <v-autocomplete v-model="data.idOperacion" label="Operación" :items="operaciones" item-value="idOperacion"
                  item-text="articulo" clearable />
              </v-col>
            
              <v-col cols="3">
                <v-autocomplete v-model="data.idMaquinaInstancia" label="Máquina" :items="instancias" item-value="idMaquinaIns"
                  item-text="nombre" clearable />
              </v-col>
            
              <v-col cols="3">
                <v-autocomplete v-model="data.idToken" label="Token" :items="tokensExtrasMaquina" item-value="idTokenExtra"
                  :item-text="nombreToken" clearable />
              </v-col>

              <v-col cols="3">
                <v-autocomplete
                  v-model="data.causa"
                  :items="causas"
                  item-value="idParoTipo"
                  item-text="nombre"
                  label="Causa (opcional)"
                  hide-details
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  v-model="data.subcausa"
                  :items="subcausasFiltradas"
                  item-value="idSubParoTipo"
                  item-text="nombreSubParoTipo"
                  label="Subcausa (opcional)"
                  hide-details
                  clearable
                ></v-autocomplete>
              </v-col>  

              <v-col cols="12">
                <v-file-input
		      		v-model="selectedUpdateFile"
		      		accept=".csv, .xls, .xlsx"
		      		@change="cambioficheroCargaJson"
		      		counter
		      		show-size
		      		clearable
		      		label="Formato xlsx en formato general (Sin formato especifico)"
		      	></v-file-input>
              </v-col>
            
		      		<v-col cols="12" class="py-0">
		      			<v-btn
		      				block
		      				color="blue"
		      				outlined
		      				class="my-2 mb-4"
		      				@click="cargaMasivaPost"
		      				>Cargar</v-btn
		      			>
		      		</v-col>
              <v-col cols="12" class="py-0">
		      			<v-btn
		      				block
		      				color="red"
		      				outlined
		      				class="my-2 mb-4"
		      				@click="descargarPlantillaParosMasivos"
		      				>Descargar Plantilla</v-btn
		      			>
		      		</v-col>
		      	</v-row>
		      </v-card-text>
				</v-tab-item>
				
			</v-tabs-items>
		</v-tabs>
  </div>
  
</template>

<script>
import { mapState } from "vuex";
import axios from 'axios';
import datePicker from "@/components/DatePicker";

export default {
  components: {
    datePicker
  },
  data() {
    return {
      causas: [],
      subcausas: [],
      dialog: false,

      data: {
        idOrdenTrabajo: null,
        idDetalleOrdenTrabajo: null,
        idOperacion: null,
        idMaquinaInstancia: null,
        idToken: null,
        fecha: null,
        archivo: null,
        causa: null,
        subcausa: null
      },

      instancias: [],
      tokens: [],
      Tbtdboper: [],

      loadingInstancias: false,
      loadingTokens: false,
      loadingCargaDescarga: false,
      loadingTbtdboper: false,
      loadingCargaMasiva: false,

      ficheroCarga: null,
      cargaCargaCompleta: false,
      errorCargaMasiva: false,
      selectedUpdateFile: null,
      tab: 0,
      ficheroActualizacion: null,
      loadingCargaMasiva: false,
    }
  },
  methods: {
    initialize() {
      this.getTbtdboper();
      this.getInstancias();
      this.getTokens();
      this.getCausas();
      this.getTipoSubParos();
    },
    getCausas() {
        axios
          .get("/ParoTipos/ParoTipo")
          .then(response => {
            this.causas = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
    getTipoSubParos() {
			axios
				.get("/SubParoTipos")
				.then((response) => {
					this.subcausas = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
    nombreToken: (value) => `[${value.token}] - ${value.multiplicador == true ?'Virtual':'Fisico'}`,
    getTbtdboper() {
      this.loadingTbtdboper = true;
      axios
        .get("/Reportes/Tbtdboper")
        .then(response => this.Tbtdboper = response.data)
        .catch(error => console.log(error))
        .finally(() => {
          this.loadingTbtdboper = false;
        })
    },

    getInstancias() {
      this.loadingInstancias = true;
      axios
        .get("/MaquinaInstancias")
        .then(response => this.instancias = response.data)
        .catch(error => console.log(error))
        .finally(() => {
          this.loadingInstancias = false;
        })
    },
    getTokens() {
      this.loadingTokens = true;
      axios
        .get(`/MaquinaInstancias/TokensMaquinsIns`)
        .then(response => this.tokens = response.data)
        .catch(error => console.log(error))
        .finally(() => {
          this.loadingTokens = false;
        })
    },
    descargarPlantilla() {
      this.loadingCargaDescarga = true;

      const url = `/api/Reportes/PlantillaCargaMasivaAvancesProduccion?access_token=${this.token}`;
      window.open(url, '_blank');

      // Simular una espera de 1 segundo para desactivar loading (puedes ajustar esto)
      setTimeout(() => {
        this.loadingCargaDescarga = false;
      }, 3000);
    },
    descargarPlantillaParosMasivos() {
      this.loadingCargaDescarga = true;

      const url = `/api/Reportes/PlantillaCargaMasivaParos?access_token=${this.token}`;
      window.open(url, '_blank');

      // Simular una espera de 1 segundo para desactivar loading (puedes ajustar esto)
      setTimeout(() => {
        this.loadingCargaDescarga = false;
      }, 3000);
    },

    abrirDialog() {
      this.dialog = true;
    },
    cambioficheroCarga(event) {
      const allowedTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel', // .xls
        'text/csv' // .csv
      ];

      if (!allowedTypes.includes(event.type)) {
        this.$toast.error('Tipo de archivo no válido');
        this.selectedUpdateFile = null;
        return;
      }
      if (typeof event === "undefined" || event == null)
        this.selectedUpdateFile = null;
      else this.selectedUpdateFile = event;
    },
    // cargaProduccionMasiva() {
    //   if (this.selectedUpdateFile != null) {
    //     this.loadingCargaMasiva = true;
    //     let formData = new FormData();
    //     formData.append("archivo", this.selectedUpdateFile);
    //     let url = `/Reportes/CargaMasivaAvancesProduccion`;
    //     axios
    //       .post(url, formData, {
    //         headers: {
    //           "Content-Type": "multipart/form-data",
    //         },
    //       })
    //       .then((response) => {
    //         this.cargaLink = response.data;
    //         this.cargaCargaCompleta = true;
    //         this.loadingCargaMasiva = false;
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //         this.loadingCargaMasiva = false;
    //         this.errorCargaMasiva = true;
    //       });
    //   }
    // },
    cargaProduccionMasiva() {
      if (this.selectedUpdateFile != null) {
        this.loadingCargaMasiva = true;

        const formData = new FormData();
        formData.append("file", this.selectedUpdateFile);

        const idArea = this.getIdAreaFromOperacion(this.data.idOperacion, this.Tbtdboper);

        const query = new URLSearchParams({
          IdTrabajoOrden: this.data.idOrdenTrabajo,
          IdTrabajoOrdenDetalle: this.data.idDetalleOrdenTrabajo,
          IdOperacion: this.data.idOperacion,
          IdArea: idArea,
          IdMaquinaIns: this.data.idMaquinaInstancia,
          IdToken: this.data.idToken
        }).toString();

        const url = `/Reportes/CargaMasivaAvancesProduccion?${query}`;

        axios
          .post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.cargaLink = response.data;
            this.cargaCargaCompleta = true;
            this.loadingCargaMasiva = false;
          })
          .catch((error) => {
            console.error(error);
            this.loadingCargaMasiva = false;
            this.errorCargaMasiva = true;
          });
      }
    },

    resetCargaMasiva() {
      this.ficheroCarga = null;
      this.cargaCargaCompleta = false;
      this.loadingCargaMasiva = false;
      this.errorCargaMasiva = false;
      this.selectedUpdateFile = null;
    },
    resetData() {
      this.data = {
        idOrdenTrabajo: null,
        idDetalleOrdenTrabajo: null,
        idOperacion: null,
        idMaquinaInstancia: null,
        idToken: null,
        fecha: null,
        archivo: null
      };
    },

    getIdAreaFromOperacion(idOperacionBuscado, listaTrabajoOrdenes) {
      for (const orden of listaTrabajoOrdenes) {
        for (const detalle of orden.trabajoOrdenesDetalles) {
          for (const operacion of detalle.operaciones) {
            if (operacion.idOperacion === idOperacionBuscado) {
              return operacion.idArea;
            }
          }
        }
      }
      return null; // No encontrado
    },
    cargaMasivaPost() {
            if (this.ficheroCarga != null) {
                this.loadingCargaMasiva = true;
				let formData = new FormData();
				formData.append("file", this.ficheroCarga);

        const idArea = this.getIdAreaFromOperacion(this.data.idOperacion, this.Tbtdboper);

        const query = new URLSearchParams({
          IdTrabajoOrden: this.data.idOrdenTrabajo,
          IdTrabajoOrdenDetalle: this.data.idDetalleOrdenTrabajo,
          IdOperacion: this.data.idOperacion,
          IdArea: idArea,
          IdMaquinaIns: this.data.idMaquinaInstancia,
          IdToken: this.data.idToken,
          IdParoTipo: this.data.causa,
          /* IdSubParoTipo: this.data.subcausa */
        }).toString();

        const url = `/Reportes/RegistrarHistorialParos2?${query}`;

				axios
        .post(url, formData, {
						headers: {
							"Content-Type": "multipart/form-data",
						},
					})
					.then((response) => {
						this.cargaLink = response.data;
						this.cargaCargaCompleta = true;
						this.loadingCargaMasiva = false;
					})
					.catch((error) => {
						console.log(error);
						this.loadingCargaMasiva = false;
						this.errorCargaMasiva = true;
					});
			}
		},
    cambioficheroCargaJson(event) {
			if (typeof event === "undefined" || event == null)
				this.ficheroCarga = null;
			else this.ficheroCarga = event;
		},
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    trabajoOrdenesDetalles() {
      this.data.idDetalleOrdenTrabajo = null;
      this.data.idOperacion = null;
      const ordenSeleccionada = this.Tbtdboper.find(
        odt => odt.idTrabajoOrden === this.data.idOrdenTrabajo
      );

      return ordenSeleccionada ? ordenSeleccionada.trabajoOrdenesDetalles : [];
    },
    operaciones() {
      this.data.idOperacion = null;
      const ordenSeleccionada = this.Tbtdboper.find(
        odt => odt.idTrabajoOrden === this.data.idOrdenTrabajo
      );

      if (!ordenSeleccionada) return [];

      const detalleSeleccionado = ordenSeleccionada.trabajoOrdenesDetalles.find(
        detalle => detalle.idTrabajoOrdenDetalle === this.data.idDetalleOrdenTrabajo
      );

      return detalleSeleccionado ? detalleSeleccionado.operaciones : [];
    },
    tokensExtrasMaquina() {
      this.data.idToken = null;
      const tokens = this.tokens.find(
        m => m.idMaquinaIns === this.data.idMaquinaInstancia
      );
      return tokens ? tokens.tokensExtras : [];
    },
    comprobacionFormulario() {
      return this.data.idOrdenTrabajo && this.data.idDetalleOrdenTrabajo && this.data.idOperacion && this.data.idMaquinaInstancia && this.data.idToken;
    },
    subcausasFiltradas() {
      return this.data.causa
        ? this.subcausas.filter(s => s.idParoTipo === this.data.causa)
        : [];
      },
      nombreCausas() {
        return Object.fromEntries((this.causas || []).map(c => [c.idParoTipo, c.nombre]));
      },
      nombreSubcausas() {
        return Object.fromEntries((this.subcausas || []).map(s => [s.idSubParoTipo, s.nombreSubParoTipo]));
      },
      cambioSubcausa() {
        return Object.fromEntries((this.subcausas || []).map(s => [s.idSubParoTipo, s.idParoTipo]));
      },
  },
  mounted() {
    this.initialize();
  }
};
</script>
